import { partner } from '../api/partner';
import { useSession } from '../app/session';
import { useI18n, useT } from '../i18n';

/** Native select: the most familiar picker on phones. Languages come from the API (new ones appear without code). */
export function LanguageSelect({ id = 'lang' }: { id?: string }) {
  const t = useT();
  const locale = useI18n((s) => s.locale);
  const locales = useI18n((s) => s.locales);
  const setLocale = useI18n((s) => s.setLocale);
  const authed = useSession((s) => s.status === 'authed' || s.status === 'must_change');
  const choose = (code: string) => {
    setLocale(code);
    // signed in → also remember on the account (follows the person to another phone); offline/errors are harmless
    if (authed) {
      useI18n.getState().setAccountLocale(code);
      partner.saveLocale(code).catch(() => undefined);
    }
  };
  return (
    <div>
      <label htmlFor={id} className="label">
        {t('settings.language')}
      </label>
      <select id={id} className="input" value={locale} onChange={(e) => choose(e.target.value)}>
        {locales.map((l) => (
          <option key={l.code} value={l.code} lang={l.code}>
            {l.name}
          </option>
        ))}
      </select>
    </div>
  );
}
